import { trackApplicationLead } from "@/lib/metaPixel";

/**
 * Keeps one submission id per unchanged payload so network retries are idempotent on the server.
 * Editing any answer after a failure starts a new id (the server would reject reuse with 409).
 */
export function createSubmissionAttempt() {
  let last: { key: string; id: string; ts: string } | null = null;
  return (payload: unknown) => {
    const key = JSON.stringify(payload);
    if (!last || last.key !== key) last = { key, id: crypto.randomUUID(), ts: new Date().toISOString() };
    return { id: last.id, ts: last.ts };
  };
}

const STORE = "ta_lead_receipts";
const memory = new Set<string>();

function readStored(): string[] {
  try {
    const parsed: unknown = JSON.parse(sessionStorage.getItem(STORE) ?? "[]");
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === "string") : [];
  } catch { return []; }
}

/**
 * Fires Meta Lead once per server receipt, across remounts and replays in this browser session.
 * Never throws: tracking must not turn a saved lead into a failed form.
 */
export function trackLeadOnce(receipt: string | undefined, legacyParams: Record<string, string>, label: string) {
  try {
    if (!receipt) return;
    if (memory.has(receipt)) return;
    const seen = readStored();
    if (seen.includes(receipt)) { memory.add(receipt); return; }
    memory.add(receipt);
    try { sessionStorage.setItem(STORE, JSON.stringify([...seen, receipt].slice(-20))); } catch { /* storage blocked/full: in-memory set still dedupes */ }
    trackApplicationLead(legacyParams, label);
  } catch { /* never break success */ }
}

/** Test-only reset of the in-memory guard. */
export function __resetLeadMemory() { memory.clear(); }
